// config.js
export const BASE_URL = "https://ldtapp.asayafreight.net";
export const companyName = "LDT";
export const fullCompanyName = "LDT Transport Inc.";
export const address = "720 Sutter Ave West Sacramento CA 95691";
export const email = "ldt.trans@gmail.com";
export const dot = "1420414";
export const mc = "537273";

// Capital Containers Transport LLC
// 720 Sutter Ave West Sacramento CA 95691
// capitalcontainers@gmail.com
// DOT 3682624
// MC 1281567
// this one has to work
// LDT Transport Inc.
// 720 Sutter Ave West Sacramento CA 95691
// ldt.trans@gmail.com
// USDOT 1420414
// MC 537273
